import {
  FaBaby,
  FaPaw,
  FaHamburger,
  FaHammer,
  FaBroom,
  FaGraduationCap,
  FaTruck,
  FaGuitar,
  FaLaptopCode,
  FaHeartbeat,
  FaLanguage,
  FaPaintBrush,
  FaCamera,
  FaSpa,
  FaChild,
  FaConciergeBell,
  FaBalanceScale,
  FaPlane,
} from "react-icons/fa";
import { FaScissors } from "react-icons/fa6";
import { ReactElement } from "react";

export interface ServiceItem {
  slug: string;
  title: string;
  icon: ReactElement;
  color?: string;
}

export const services: ServiceItem[] = [
  {
    slug: "food",
    title: "Food",
    color: "#D3DC7C",
    icon: <FaHamburger size={26} className="text-white h-5 lg:h-7" />,
  },
  {
    slug: "health-wellness",
    title: "Health & Wellness",
    color: "#C0C973",
    icon: <FaHeartbeat size={26} className="text-white h-5 lg:h-7" />,
  },
  {
    slug: "tutoring",
    title: "Tutoring",
    color: "#C0C973",
    icon: <FaGraduationCap size={26} className="text-white h-5 lg:h-7" />,
  },
  {
    slug: "beauty",
    title: "Beauty",
    color: "#EEC94C",
    icon: <FaSpa size={26} className="text-white h-5 lg:h-7" />,
  },
  {
    slug: "catering",
    title: "Catering",
    color: "#D3DC7C",
    icon: <FaConciergeBell size={26} className="text-white h-5 lg:h-7" />,
  },
  {
    slug: "photography",
    title: "Photography",
    color: "#FAD564",
    icon: <FaCamera size={26} className="text-white h-5 lg:h-7" />,
  },
  {
    slug: "hairdresser",
    title: "Hairdresser",
    color: "#F0F4C3",
    icon: <FaScissors size={26} className="text-white h-5 lg:h-7" />,
  },
  {
    slug: "cleaning",
    title: "Cleaning",
    color: "#EEE5C2",
    icon: <FaBroom size={26} className="text-white h-5 lg:h-7" />,
  },
  {
    slug: "legal",
    title: "Legal",
    color: "#A3A3F3",
    icon: <FaBalanceScale size={26} className="text-white h-5 lg:h-7" />,
  },
  {
    slug: "babysitting",
    title: "Babysitting",
    color: "#FAD564",
    icon: <FaBaby size={26} className="text-white h-5 lg:h-7" />,
  },
  {
    slug: "pet-sitting",
    title: "Pet Sitting",
    color: "#8EBD9D",
    icon: <FaPaw size={26} className="text-white h-5 lg:h-7" />,
  },
  {
    slug: "delivery-moving",
    title: "Delivery & Moving",
    color: "#77A885",
    icon: <FaTruck size={26} className="text-white h-5 lg:h-7" />,
  },
  {
    slug: "coaching",
    title: "Coaching",
    color: "#F0C8D0",
    icon: <FaGraduationCap size={26} className="text-white h-5 lg:h-7" />,
  },
  {
    slug: "entertainment-art",
    title: "Entertainment & Art",
    color: "#D9A5B3",
    icon: <FaPaintBrush size={26} className="text-white h-5 lg:h-7" />,
  },
  {
    slug: "house-repairing",
    title: "House Repairing",
    color: "#E5DAB3",
    icon: <FaHammer size={26} className="text-white h-5 lg:h-7" />,
  },
  {
    slug: "travel",
    title: "Travel",
    color: "#FAD564",
    icon: <FaPlane size={26} className="text-white h-5 lg:h-7" />,
  },
  {
    slug: "childcare",
    title: "Childcare",
    color: "#FAD564",
    icon: <FaChild size={26} className="text-white h-5 lg:h-7" />,
  },
  {
    slug: "it-support",
    title: "IT Support",
    color: "#FAD564",
    icon: <FaLaptopCode size={26} className="text-white h-5 lg:h-7" />,
  },
  {
    slug: "music-lessons",
    title: "Music Lessons",
    color: "#8EBD9D",
    icon: <FaGuitar size={26} className="text-white h-5 lg:h-7" />,
  },
  {
    slug: "language-support",
    title: "Language Support",
    color: "#F0F4C3",
    icon: <FaLanguage size={24} className="text-white h-5 lg:h-7" />,
  },
];
